export default __webpack_public_path__ + "static/media/powerbitips-black.5e5892d0.svg";